var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescQuadroPopAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 833,
    height: 837,
    viewBox: "0 0 833 837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-pop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M156.415,169.246A4.574,4.574,0,1,1,161,164.672a4.578,4.578,0,0,1-4.585,4.574Zm0-32.02A4.574,4.574,0,1,1,161,132.653a4.578,4.578,0,0,1-4.585,4.574Zm0-32.02A4.574,4.574,0,1,1,161,100.633a4.578,4.578,0,0,1-4.585,4.574Zm0-32.02A4.574,4.574,0,1,1,161,68.614a4.578,4.578,0,0,1-4.585,4.574Zm0-32.02A4.574,4.574,0,1,1,161,36.594,4.578,4.578,0,0,1,156.415,41.168Zm0-32.02A4.574,4.574,0,1,1,161,4.574,4.578,4.578,0,0,1,156.415,9.149Zm-30.106,160.1a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm-30.1,160.1a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,96.2,73.188Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,96.2,41.168Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,96.2,9.148Zm-31.415,160.1a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm-30.105,160.1a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm-30.1,160.1a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02A4.574,4.574,0,1,1,9.171,4.574,4.578,4.578,0,0,1,4.585,9.149ZM156.415,362A4.574,4.574,0,1,1,161,357.426,4.578,4.578,0,0,1,156.415,362Zm0-32.02A4.574,4.574,0,1,1,161,325.406,4.578,4.578,0,0,1,156.415,329.98Zm0-32.02A4.574,4.574,0,1,1,161,293.387,4.578,4.578,0,0,1,156.415,297.961Zm0-32.02A4.574,4.574,0,1,1,161,261.367a4.578,4.578,0,0,1-4.585,4.574Zm0-32.02A4.574,4.574,0,1,1,161,229.348a4.578,4.578,0,0,1-4.585,4.574Zm0-32.02A4.574,4.574,0,1,1,161,197.328,4.578,4.578,0,0,1,156.415,201.9ZM126.312,362a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,126.312,362Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574ZM96.208,362a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,96.208,362Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574ZM64.792,362a4.574,4.574,0,1,1,4.585-4.574A4.578,4.578,0,0,1,64.792,362Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574A4.578,4.578,0,0,1,64.792,329.98Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574A4.578,4.578,0,0,1,64.792,297.961Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574,4.578,4.578,0,0,1-4.585,4.574Zm0-32.02a4.574,4.574,0,1,1,4.585-4.574A4.578,4.578,0,0,1,64.792,201.9ZM34.687,362a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,34.687,362Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,34.687,329.98Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,34.687,297.961Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,34.687,201.9ZM4.585,362a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,4.585,362Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574,4.578,4.578,0,0,1-4.586,4.574Zm0-32.02a4.574,4.574,0,1,1,4.586-4.574A4.578,4.578,0,0,1,4.585,201.9Z",
    transform: "translate(0 0)",
    fill: "#444f57"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-pop",
    x: 94,
    y: 0,
    width: 645,
    height: 837,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-pop-2",
    x: 0,
    y: 261,
    width: 833,
    height: 315,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pop_newcustomer",
    transform: "translate(-200.5 -3936.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51963",
    "data-name": "Group 51963",
    transform: "translate(4716.5 6987.456) rotate(-180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_712",
    "data-name": "Line 712",
    y2: 141,
    transform: "translate(3781.5 2576.5)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_713",
    "data-name": "Line 713",
    y2: 140.776,
    transform: "translate(3795.559 2576.529)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 1.529
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_714",
    "data-name": "Line 714",
    y2: 140.776,
    transform: "translate(3809.618 2576.559)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 2.059
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_715",
    "data-name": "Line 715",
    y2: 140.776,
    transform: "translate(3823.677 2576.588)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 2.588
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_716",
    "data-name": "Line 716",
    y2: 140.776,
    transform: "translate(3837.735 2576.618)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 3.118
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_717",
    "data-name": "Line 717",
    y2: 140.776,
    transform: "translate(3851.794 2576.647)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 3.647
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_718",
    "data-name": "Line 718",
    y2: 140.776,
    transform: "translate(3865.853 2576.677)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 4.176
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_719",
    "data-name": "Line 719",
    y2: 140.776,
    transform: "translate(3879.912 2576.706)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 4.706
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_720",
    "data-name": "Line 720",
    y2: 140.776,
    transform: "translate(3893.971 2576.735)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 5.235
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_721",
    "data-name": "Line 721",
    y2: 140.776,
    transform: "translate(3908.029 2576.765)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 5.765
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_722",
    "data-name": "Line 722",
    y2: 140.776,
    transform: "translate(3922.088 2576.794)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 6.294
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_723",
    "data-name": "Line 723",
    y2: 140.776,
    transform: "translate(3936.147 2576.823)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 6.824
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_724",
    "data-name": "Line 724",
    y2: 140.776,
    transform: "translate(3950.206 2576.853)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 7.353
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_725",
    "data-name": "Line 725",
    y2: 140.776,
    transform: "translate(3964.265 2576.882)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 7.882
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_726",
    "data-name": "Line 726",
    y2: 140.776,
    transform: "translate(3978.323 2576.912)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 8.412
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_727",
    "data-name": "Line 727",
    y2: 140.776,
    transform: "translate(3992.382 2576.941)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 8.941
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_728",
    "data-name": "Line 728",
    y2: 140.776,
    transform: "translate(4006.441 2576.971)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 9.471
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_729",
    "data-name": "Line 729",
    y2: 140.776,
    transform: "translate(4020.5 2577)",
    fill: "none",
    stroke: "#455057",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51983",
    "data-name": "Group 51983",
    transform: "translate(1869.209 3987.678) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(762.001 1380.586) rotate(90)",
    clipPath: "url(#clip-path-pop)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M0,0H171.19V372.225H0Z",
    transform: "translate(-5.095 -5.113)",
    fill: "#444f57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Customer",
    transform: "translate(180 3342.68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 20.5, 593.5)",
    filter: "url(#Base-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-pop-3",
    "data-name": "Base",
    width: 390,
    height: 582,
    transform: "translate(219.5 122.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Save",
    transform: "translate(544 1263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 76,
    height: 24,
    rx: 4,
    fill: "#b54756"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Create",
    transform: "translate(37 15)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.551,
    y: 0
  }, "Create"))), /*#__PURE__*/React.createElement("g", {
    id: "Cancel",
    transform: "translate(495 1268)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Cancel-2",
    "data-name": "Cancel",
    transform: "translate(31 10)",
    fill: "#3a4750",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.596,
    y: 0
  }, "Cancel"))), /*#__PURE__*/React.createElement("g", {
    id: "Birth_Place",
    "data-name": "Birth Place",
    transform: "translate(441 1162)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Birth_Place-2",
    "data-name": "Birth Place",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Birth Place")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 178,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Birth_Place-3",
    "data-name": "Birth Place",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Birth Place"))), /*#__PURE__*/React.createElement("g", {
    id: "Date_of_Birth",
    "data-name": "Date of Birth",
    transform: "translate(251 1162)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Date_of_Birth-2",
    "data-name": "Date of Birth",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Date of Birth")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-2",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 178,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "GG_MM_AAAA",
    "data-name": "GG/MM/AAAA",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GG/MM/AAAA")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-calendar",
    "data-name": "Icon ionic-ios-calendar",
    transform: "translate(157.345 18.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33206",
    "data-name": "Path 33206",
    d: "M18.024,6.75H16.465v1a.324.324,0,0,1-.312.334H15.53a.324.324,0,0,1-.312-.334v-1H7.738v1a.324.324,0,0,1-.312.334H6.8a.324.324,0,0,1-.312-.334v-1H4.933A1.621,1.621,0,0,0,3.375,8.419v11.35a1.621,1.621,0,0,0,1.558,1.669h13.09a1.621,1.621,0,0,0,1.558-1.669V8.419A1.621,1.621,0,0,0,18.024,6.75Zm.312,12.518a.811.811,0,0,1-.779.835H5.4a.811.811,0,0,1-.779-.835V11.757a.324.324,0,0,1,.312-.334h13.09a.324.324,0,0,1,.312.334Z",
    transform: "translate(-3.375 -5.231)",
    fill: "#3a4750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33207",
    "data-name": "Path 33207",
    d: "M10.519,4.88a.381.381,0,0,0-.38-.38H9.38A.381.381,0,0,0,9,4.88v1.14h1.519Z",
    transform: "translate(-5.94 -4.5)",
    fill: "#3a4750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33208",
    "data-name": "Path 33208",
    d: "M26.269,4.88a.381.381,0,0,0-.38-.38h-.76a.381.381,0,0,0-.38.38v1.14h1.519Z",
    transform: "translate(-13.122 -4.5)",
    fill: "#3a4750"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cell_Number",
    "data-name": "Cell Number",
    transform: "translate(251 1111)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Cell_Number-2",
    "data-name": "Cell Number",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cell Number")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-3",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Cell_Number-3",
    "data-name": "Cell Number",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cell Number"))), /*#__PURE__*/React.createElement("g", {
    id: "Phone_Number",
    "data-name": "Phone Number",
    transform: "translate(251 1060)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Phone_Number-2",
    "data-name": "Phone Number",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Phone Number")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-4",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Phone_Number-3",
    "data-name": "Phone Number",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Phone Number"))), /*#__PURE__*/React.createElement("g", {
    id: "Language",
    transform: "translate(251 1010)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Language-2",
    "data-name": "Language",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Language")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-5",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Language-3",
    "data-name": "Language",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Language"))), /*#__PURE__*/React.createElement("g", {
    id: "Nationality",
    transform: "translate(251 959)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Nationality-2",
    "data-name": "Nationality",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Nationality")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-6",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Nationality-3",
    "data-name": "Nationality",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Nationality"))), /*#__PURE__*/React.createElement("g", {
    id: "Last_Name",
    "data-name": "Last Name",
    transform: "translate(251 908)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Last_Name-2",
    "data-name": "Last Name",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Last Name")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-7",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Last_Name-3",
    "data-name": "Last Name",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Last Name"))), /*#__PURE__*/React.createElement("g", {
    id: "First_Name",
    "data-name": "First Name",
    transform: "translate(251 858)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "First_Name-2",
    "data-name": "First Name",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "First Name")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-8",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "First_Name-3",
    "data-name": "First Name",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "First Name"))), /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(251 807)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Email-2",
    "data-name": "Email",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Email")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-9",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Email-3",
    "data-name": "Email",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Email"))), /*#__PURE__*/React.createElement("g", {
    id: "Sex",
    transform: "translate(441 757)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sex-2",
    "data-name": "Sex",
    transform: "translate(1 9)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sex")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-10",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 178,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Sex-3",
    "data-name": "Sex",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sex")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M9,13.5l4.052,4.052L17.1,13.5Z",
    transform: "translate(156.448 11.486)",
    fill: "#3a4750"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(251 757)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Title-2",
    "data-name": "Title",
    transform: "translate(1 9)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Title")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-11",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 178,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Title-3",
    "data-name": "Title",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Title")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown-2",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M9,13.5l4.052,4.052L17.1,13.5Z",
    transform: "translate(156.448 11.486)",
    fill: "#3a4750"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Title-4",
    "data-name": "Title",
    transform: "translate(251 1212)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Marital_Status",
    "data-name": "Marital Status",
    transform: "translate(1 8)",
    fill: "#3a4750",
    fontSize: 8,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Marital Status")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315-12",
    "data-name": "Rectangle 315",
    transform: "translate(0 14)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 26,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 25,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Select_Marital_Status",
    "data-name": "Select Marital Status",
    transform: "translate(7 29)",
    fill: "#b5b5b5",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Select Marital Status")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown-3",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M9,13.5l4.052,4.052L17.1,13.5Z",
    transform: "translate(346.208 11.486)",
    fill: "#3a4750"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Customer-2",
    "data-name": "Customer",
    transform: "translate(251 742)",
    fill: "#3a4750",
    fontSize: 16,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Customer"))), /*#__PURE__*/React.createElement("g", {
    id: "Address",
    transform: "translate(-918 3796.68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1118.5, 139.5)",
    filter: "url(#Base-pop-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-4",
    "data-name": "Base",
    width: 578,
    height: 60,
    transform: "translate(125.5 383.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(1770 535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ic_dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base-5",
    "data-name": "base",
    width: 36,
    height: 36,
    rx: 4,
    fill: "#b54756"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add",
    "data-name": "Icon ionic-ios-add",
    d: "M23.969,15.969H17.961V9.961a1,1,0,0,0-1.992,0v6.008H9.961a1,1,0,0,0,0,1.992h6.008v6.008a1,1,0,1,0,1.992,0V17.961h6.008a1,1,0,0,0,0-1.992Z",
    transform: "translate(1.035 1.035)",
    fill: "#eff1f3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Title-5",
    "data-name": "Title",
    transform: "translate(1260 561)",
    fill: "#3a4750",
    fontSize: 24,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Address"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescQuadroPopAddress);
export default __webpack_public_path__ + "static/media/desc-quadro-pop-address.d36a8fccdf92a72fcae769ddb15ebaef.svg";
export { ForwardRef as ReactComponent };